import { Spinner } from "minimum-ui/core";
export default Spinner;
